import {
  SUBSCRIBE_NEW_USER,
  GET_ALL_MARKETPLACE_PRODUCTS,
  GET_ONE_MARKETPLACE_PRODUCT,
  GET_PLANS,
  PURCHASE_PRODUCT
} from '../actions/stripeActions'

export default function (state = {}, action) {
  switch (action.type) {
    case SUBSCRIBE_NEW_USER:
      return { ...state, subscribeResponse: action.payload }
    case GET_ALL_MARKETPLACE_PRODUCTS:
      return { ...state, marketplaceProducts: action.payload }
    case GET_ONE_MARKETPLACE_PRODUCT:
      return { ...state, selectedProduct: action.payload }
    case GET_PLANS:
      return { ...state, stripePlans: action.payload }
    case PURCHASE_PRODUCT:
      return { ...state, purchaseResponse: action.payload }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/stripeReducer.js